import React from 'react'
import './style.scss'

export function InvoiceTag({ tagInfo = {}, className = '' }) {
  const { text, color } = tagInfo

  return (
    <div className={`container-status ${className} ${color}`}>
      <div className='dot' />
      <span className='text'>{text}</span>
    </div>
  )
}
